import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';

interface CompareActionsProps {
	selectedCount: number;
	totalCount: number;
	onCompare: () => void;
	onClearSelection: () => void;
}

export const CompareActions: React.FC<CompareActionsProps> = ({
	selectedCount,
	totalCount,
	onCompare,
	onClearSelection
}) => {
	const allSelected = selectedCount === totalCount;
	const selectedText = `${COPY_SPECIFIC.COMPARE} ${allSelected ? `${COPY_SPECIFIC.ALL} ` : ''}${selectedCount}`;
	const itemsText = `${allSelected ? `${COPY_SPECIFIC.ALL} ` : ''}${selectedCount} ` +
		`${COPY_SPECIFIC.ITEMS} ${COPY_SPECIFIC.SELECTED}`;

	return (
		<div className='compare-actions'>
			<Button
				onClick={ onCompare }
				type='primary'>
				{ selectedText }
			</Button>
			<span className='selection-text'>{ itemsText }</span>
			<Button
				onClick={ onClearSelection }
				size='small'
				type='link'>
				{ COPY_SPECIFIC.CLEAR_SELECTION }
			</Button>
		</div>
	);
};
